/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { imagesGetApiV3ImagesNeuronsNeuronIdPng } from "../../funcs/imagesGetApiV3ImagesNeuronsNeuronIdPng.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3ImagesNeuronsNeuronIdPngRequest$inboundSchema,
};

export const tool$imagesGetApiV3ImagesNeuronsNeuronIdPng: ToolDefinition<
  typeof args
> = {
  name: "images-get-api-v3-images-neurons-neuron-id-png",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await imagesGetApiV3ImagesNeuronsNeuronIdPng(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
